export enum Direction {
  NONE = 0,
  LEFT = 1,
  UP = 2,
  RIGHT = 3,
  DOWN = 4,
  LEFT_UP = 5,
  LEFT_DOWN = 6,
  RIGHT_UP = 7,
  RIGHT_DOWN = 8,
}
